import { useTranslation } from "react-i18next";
import { namespaces } from "../../consts/i18n";
import useAuthInfo from "../../hooks/useAuthInfo";
import { getErrorForPath } from "../../utils/serverIssuesUtils";
import DownloadFiles from "../inputs/DownloadFiles";
import FilesInput from "../inputs/FilesInput";
import InputLabel from "../inputs/InputLabel";
import { TextInputSmall } from "../inputs/TextInput";
import TogglesSelect from "../inputs/TogglesSelect";

const ServiceForm = ({ data, onChange, issues }) => {
  const { t } = useTranslation(namespaces.viewer);

  const allowedServiceTypes = [
    { label: t("form.INSURANCE_EVENT"), value: "INSURANCE_EVENT" },
    { label: t("form.WARRANTY"), value: "WARRANTY" },
    { label: t("form.POST_WARRANTY"), value: "POST_WARRANTY" },
  ];

  const { canEdit } = useAuthInfo();

  const currentServiceType = data.type || allowedServiceTypes[1].value;

  const setData = (newData) => {
    onChange(newData);
  };

  const handleTextChange = (name) => (value) => {
    setData({ ...data, [name]: value });
  };

  const handleFilesChange = (files) => {
    setData({ ...data, files: files });
  };

  return (
    <div className="flex flex-col gap-[20px] bg-bg1 rounded-xl">
      <TogglesSelect
        label={t("form.recordType")}
        options={allowedServiceTypes}
        selectedOption={currentServiceType}
        onChange={({ value }) => {
          setData({
            ...data,
            recordType: "SERVICE",
            type: value,
          });
        }}
      />
      <div>
        <TextInputSmall
          disabled={!canEdit}
          extraError={getErrorForPath(issues, ["note"])}
          lightTheme={true}
          label={t("form.note")}
          value={data.note ?? ""}
          onChange={handleTextChange("note")}
        />
      </div>

      <div>
        <InputLabel>{t("form.files")}</InputLabel>

        <DownloadFiles
          disabled={!canEdit}
          files={data.photos || []}
          onFilesChange={(_files, event) => {
            event?.stopPropagation?.();
            event?.preventDefault?.();
            setData({ ...data, photos: _files });
          }}
          displayFileSizes={true}
          lightTheme={true}
        />
        <div className="h-[13px]"></div>
        <FilesInput
          disabled={!canEdit}
          lightTheme={true}
          dropAreaLabel={t("form.dropAreaLabel")}
          files={data.files || []}
          onChange={handleFilesChange}
        />
      </div>
    </div>
  );
};

export default ServiceForm;
